<div class="d-flex flex-column">
    <div>
        <ng-content select="[tabs]"></ng-content>
    </div>
    <div>
        <app-envelope-filter [searchValue]="searchValue" [sortOptions]="sortOptions"
            [selectedSortOption]="selectedSortOption" (changeToGridModeClick)="onChangeToGrid()"
            [sortOnboardingReady]="sortOnboardingReady"
            (changeToListModeClick)="onChangeToList()" (checkAllClick)="onCheckAllClick($event)"
            (searchValueChange)="onSearchValueChange($event)" (sortOrderChange)="onSortOrderChange($event)"
            (sortChange)="onSortChange($event)" (filterChange)="onFilterChange($event)"
            (filterClear)="onFilterClear($event)"
            (filterButtonClick)="onFilterButtonClick()">
        </app-envelope-filter>
    </div>
    <div>
        <ng-content select="[list]"></ng-content>
    </div>
</div>

<ng-content select='[details-sidebar]'></ng-content>
